import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-fast-ui';
import AdminButton from './layout/AdminButton';

const sizes = {
  sm: 600,
  md: 800,
  lg: 1110,
};

const AdminPortalModal =
  ({
     open, onClose, onSave, title, children, accentColor, size, finishVerb, secondaryVerb, canSave, finishButtonID,
     showPrimaryButton, secondaryStyle
   }) => (
    <Modal open={open} size='sm' contentContainerStyle={{ width: sizes[ size ] }}>
      <Modal.Body style={{ padding: 20 }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          borderBottom: `2px solid ${accentColor}`,
          paddingBottom: 8,
          marginBottom: 8,

        }}>
          <h2 style={{ fontSize: 23 }} className='futura-pt-bold'>{title}</h2>
          <div style={{ display: 'flex' }}>
            <AdminButton
              style={secondaryStyle}
              id={`cancel-${finishButtonID}`}
              color={accentColor}
              onClick={onClose}
              inverse>
              {secondaryVerb}
            </AdminButton>
            {showPrimaryButton &&
            <AdminButton
              id={finishButtonID}
              color={canSave ? accentColor : '#d4d4d4'}
              onClick={onSave}
              disabled={!canSave}>
              {finishVerb}
            </AdminButton>
            }

          </div>
        </div>
        {children}
      </Modal.Body>
    </Modal>
  );


AdminPortalModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  onSave: PropTypes.func,
  accentColor: PropTypes.string,
  children: PropTypes.node,
  size: PropTypes.string,
  finishVerb: PropTypes.string,
  secondaryVerb: PropTypes.string,
  canSave: PropTypes.bool,
  showPrimaryButton: PropTypes.bool,
  secondaryStyle: PropTypes.object
};


AdminPortalModal.defaultProps = {
  accentColor: '#000',
  size: 'md',
  finishVerb: 'SAVE',
  secondaryVerb: 'CANCEL',
  canSave: true,
  showPrimaryButton: true,
};

export default AdminPortalModal;